import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';

import { FaHeadset } from 'react-icons/fa';
import { contactContent } from '../../../constants';



const Banner = () => {

  const emergencyNumber = contactContent.find(contact => contact.title === "call us")?.content[0];

  return (
    <section className="banner">
      <div className='content'>

        <div className='banner-1'>
          <Heading title={"Join Us in Promoting Fire Safety Excellence"} subTitle={"Ensuring Fire Safety"} linear sideHeading />
          <Button link={"Careers"} title={"Join Now"} />
        </div>

        <div className='banner-2'>
          <h4>Emergency Helpline</h4>
          <div className='banner-icon'>
            <span></span><div className='icon'><FaHeadset /></div><span></span>
          </div>
          <h6>{emergencyNumber}</h6>
          <Button link={"Contact-us"} title={"Contact Us"} />
        </div>

      </div>
    </section>
  );

};

export default Banner;